export default {
	computed: {
		$_theme() {
			return (this.$vuetify.theme.dark) ? "dark" : "light";
		}
	}
};
